import { createFileRoute } from '@tanstack/react-router'
import { VirtualReportsLayout } from 'pages/virtualReports/VirtualReportsLayout'
import { VirtualReportsListPage } from 'pages/virtualReports/VirtualReportsListPage'

const VirtualReportsRouteComponent = () => {
  const { orgId, siteId } = Route.useSearch()

  return (
    <VirtualReportsLayout>
      <VirtualReportsListPage orgId={orgId} siteId={siteId} />
    </VirtualReportsLayout>
  )
}

export const Route = createFileRoute('/virtual-reports/')({
  component: VirtualReportsRouteComponent,
  staticData: {
    title: 'Virtual Reports',
  },
})
